import { useContext } from 'react'

import { AuthContext } from './auth-context'
import { IndicationsContext } from './indications-context'
import { PropertyFormContext } from './property-context'
import { SidebarContext } from './sidebar-context'

export const useAuth = () => useContext(AuthContext)

export const useProperty = () => useContext(PropertyFormContext)

export const useSidebar = () => useContext(SidebarContext)

export const useIndications = () => useContext(IndicationsContext)
